export { StyledButton, StyledWrapper } from './loyalty-button-widget.styled.base';
